// extracted by mini-css-extract-plugin
export default {"container":"Products_container__POSXs","products":"Products_products__sduwK","menu":"Products_menu__xv3bY","list":"Products_list__tW5Ch","product":"Products_product__SLkbp"};